import Footer from './Footer';
import CustomFooter from './CustomFooter';
export {Footer};
export default CustomFooter;